// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1367":"1c0ef476","2904":"9a643bc1","5942":"9a643bc1","7016":"8691eb9e","8162":"8691eb9e"}[chunkId] + ".chunk.css";
};